<template>
  <div class="my-8 bg-white rounded text-gray-800">
    <!-- Page 1 -->
    <div style="break-after: page;">
      <p class="py-2 font-bold text-left uppercase">{{ fundName }}</p>
      <p class="py-2 font-bold text-left uppercase">{{ memberList.join(" ").toUpperCase() }}</p>
      <p class="py-2 font-bold text-left uppercase">Schedule of benefit payment instructions</p>
      <p class="py-2">Payments to which this schedule relates:
        <span v-if="ratify === 'PARTYRPROSPECTIVE'">
          all payments during the {{finYear}} financial year after the date of this notice
        </span>
        <span v-else>
          all payments during the {{finYear}} financial year
        </span>
      </p>
      <p class="py-2">
        This schedule sets out the form and priority order in
        which these benefit payments should be drawn from the
        various member accounts:
      </p>
      <div class="pt-3">
        <ol class="ml-5 list-outside list-decimal">
          <li v-for="(rule, idx) in rules" :key="idx">
            {{ processRule(rule) }}
            <div v-if="showAccounts(rule)"
              class="col-span-10 text-sm p-4 border border-gray-200 mt-2"
            >
              <p v-for="(account, idx) in accounts(rule)" :key="idx" v-html="account" />
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';
import { percent } from '@/app/filters/filters';

export default {
  name: 'pension-payment-schedule',
  mixins: [pensionInstructionMixin],
  computed: {
    memberList() {
      return this.members.flatMap((member, idx) => (idx > 0 ? `and ${member.name}` : member.name));
    },
    rules() {
      const { rules } = this.getItem;
      return rules;
    },
  },
  methods: {
    isComputedRule(rule) {
      return (typeof rule !== 'string');
    },
    processRule(rule) {
      if (this.isComputedRule(rule)) {
        return this.processedPDF(rule);
      }
      return rule;
    },
    accounts(rule) {
      const output = [];

      rule.accounts.ruleAccounts.forEach((account) => {
        let row = '';
        if (rule.extra.type === 'percentage') {
          row = `<span class="font-bold">${account.value}%</span> - `;
        }
        row += `${account.member.name} / ${account.label} / ${account.identifier} / ${percent(account.taxFree)} tax free`;
        output.push(row);
      });
      return output;
    },
  },
};
</script>
